
import React, { useState , useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import Linechart from "./Linechart";
import  {loaderBar ,  apibaseURl , currencySymbol }  from "../../functions/Function";

const Chart = (props) => {
  const [data, setData] = useState([]);
  const [isloader, setIsloader] = useState(true);
  const timer = () =>{
    setTimeout(() => {
    setIsloader(false);
  }, 1000);
} 
  const fetchData = () => {
    fetch(apibaseURl + "quickbuy")
      .then(res => res.json())
      .then((result) => {
        if (result.result == true) {
            setData(result.response);
            
            timer()

        }
      }
      )
  }

  useEffect(() => {
    fetchData();
  }, [])
    return (
        
        <>  
          {isloader == true && loaderBar(300 , 25)}
          {isloader == false &&  <Linechart id={props.activeproductchart} height={400} /> }
           
           
        </>
       

    );
}

export default Chart;
